import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

export const ThemeToggle = ({ compact = true }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggle}
      title={dark ? "Switch to light theme" : "Switch to dark theme"}
      className="w-9 h-9 rounded-md border flex items-center justify-center transition-colors duration-200 hover:bg-white/5"
      style={{ borderColor: "var(--border-strong)", background: "var(--surface)" }}
    >
      {dark ? <Sun size={14} className="text-amber-300"/> : <Moon size={14} className="text-blue-500"/>}
      {!compact && <span className="ml-2 text-xs">{dark ? "Light" : "Dark"}</span>}
    </button>
  );
};

export default ThemeToggle;
